module.exports = __webpack_public_path__ + "img/right_blue.a22ac66.png";